import type { CustomIconProps } from '../types';

const Flag = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '14'}
        height={height ?? '16'}
        viewBox="0 0 14 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H7.93062L9.99513 2.13333H13.6671V11.0933H7.80099L5.73648 8.96H1.28V16H0V0Z"
            fill="#414042"
        />
    </svg>
);

export default Flag;
